import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MyTextInputCurrency = ({ onChange, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field] = useField(props)
  return (
    <>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <span className="text-gray-500 sm:text-sm">$</span>
      </div>
      <input
        className={
          'block w-full rounded-md border-gray-300 pl-7 pr-28 ' +
          'focus:border-gray-500 focus:ring-gray-500 sm:text-sm'
        }
        onChange={onChange}
        {...field}
        {...props}
      />
    </>
  )
}
export default MyTextInputCurrency

MyTextInputCurrency.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  name: PropTypes.string,
}
